import React, { useState } from 'react';
// Data
import { faqsArray } from '../../utils/data/FaqData';

function FaqComponent() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className='grid gap-6 py-6 h-fit border-colour7 border border-solid shadow-cardShadow shadow-black rounded-lg md:max-w-[66%] lg:max-w-[50vw] md:mx-auto w-full '>
      <article className='grid grid-rows-reg gap-6 my-auto'>
        <section className='flex px-4 lg:px-6 gap-6 text-center lg:text-left items-center rounded border-b-2 border-solid border-colour7'>
          <h4 className='text-4xl -mb-2 font-titleFont rounded'>FAQ</h4>
          <h5 className='hidden lg:block font-titleFont tracking-widest'>
            Frequently Asked Questions
          </h5>
        </section>

        {/* FAQ Dropdown */}
        <section className='grid gap-4 px-4 lg:px-6'>
          {faqsArray.map((faq, index) => (
            <div key={index} className='border-b border-gray-300'>
              <button
                className='w-full text-left py-1 font-semibold md:text-base flex justify-between items-center'
                onClick={() => toggleFaq(index)}
              >
                {faq.question}
                <span>{openIndex === index ? '▲' : '▼'}</span>
              </button>
              {openIndex === index && (
                <p
                  className='text-sm text-gray-400 py-2'
                  dangerouslySetInnerHTML={{ __html: faq.answer }}
                ></p>
              )}
            </div>
          ))}
        </section>
      </article>
    </section>
  );
}

export default FaqComponent;
